import { EPayload, EActionType } from '../../repositories/cian-chat-bot/entities/action_buttons/ActionButtonSchema';
import {
  fetchProcessActionButtons,
  TProcessActionButtonsResponse,
} from '../../repositories/cian-chat-bot/v2/process-action-buttons';
import { TContext } from '../../types/context';
const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotActionButtons';

export { EPayload as EChatbotPayload, EActionType as EChatbotActionType };

export async function fetchChatbotActionButtons(
  { httpApi, logger, telemetry }: TContext,
  payload: EPayload,
): Promise<void> {
  try {
    const { statusCode, response }: TProcessActionButtonsResponse = await fetchProcessActionButtons({
      httpApi,
      parameters: {
        payload,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/fetchChatbotActionButtons.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });
    }
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      message: 'Не удалось получить кнопки чатбота',
      domain: 'src/shared/services/fetchChatbotActionButtons.ts',
    });
  }
}
